import {
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  type User,
} from "firebase/auth";

import { firebaseAuth } from "./firebase";
import { isConfiguredDevelopmentUser } from "./development-identity";

const googleProvider = new GoogleAuthProvider();

export { isConfiguredDevelopmentUser } from "./development-identity";

let developmentSignIn: Promise<User> | undefined;
let developmentBootstrap: Promise<User | null> | undefined;

async function signIn(): Promise<User> {
  if (import.meta.env.DEV) {
    const email = import.meta.env["VITE_FIREBASE_AUTH_DEV_USER_MAIL"];
    const password = import.meta.env["VITE_FIREBASE_AUTH_DEV_USER_PASSWORD"];

    if (!email || !password) {
      throw new Error("Firebase development auth credentials are missing");
    }

    developmentSignIn ??= signInWithEmailAndPassword(firebaseAuth, email, password)
      .then((result) => result.user)
      .finally(() => { developmentSignIn = undefined; });
    return developmentSignIn;
  }

  const result = await signInWithPopup(firebaseAuth, googleProvider);
  return result.user;
}

export const authService = {
  signIn,

  bootstrapDevelopmentAuth(): Promise<User | null> {
    if (!import.meta.env.DEV) return Promise.resolve(firebaseAuth.currentUser);
    developmentBootstrap ??= (async () => {
      await firebaseAuth.authStateReady();
      if (isConfiguredDevelopmentUser(firebaseAuth.currentUser)) return firebaseAuth.currentUser;
      return signIn();
    })().finally(() => { developmentBootstrap = undefined; });
    return developmentBootstrap;
  },

  signOut: async (): Promise<void> => {
    await signOut(firebaseAuth);
  },

  onAuthStateChanged: (callback: (user: User | null) => void) => {
    return onAuthStateChanged(firebaseAuth, callback);
  },

  getCurrentUser: (): User | null => {
    return firebaseAuth.currentUser;
  },
};
